const basicInformation = () => import('./basicInformation');
const serviceAdmin = () => import('./serviceAdmin');
const qcrbCloud = () => import('./qcrbCloud');
const infoManagement = () => import('./infoManagement');
const applyAdmin = () => import('./applyAdmin');
const searchList = () => import('./searchList');
const processList = () => import('@/pages/student/processList');

const cloudDiskNoCycle = () => import('@/pages/student/cloudDiskNoCycle');
const processDetails = () => import('@/pages/student/processDetails');


const langSchoolRouter = [
  {
    path: '/qcrb/student/cloudDisk/:id', name: 'qcrb_cloudDisk', component: cloudDiskNoCycle, meta: { c: 'student', a: 'lscloudDisk' }
  },
  {
    path: '/qcrb/processList', name: 'qcrb_processList', component: processList, meta: { c: 'qcrb', a: 'processList' }
  },
  {
    path: '/qcrb/student/processDetails/crmid/:crmid', name: 'qcrb_processDetails', component: processDetails, meta: { c: 'qcrb', a: 'processDetails' }
  },
];

const qcrbRouter = [
  {
    path: '/qcrb/basicInformation/:crmid', name: 'basicInformation', component: basicInformation, meta: { c: 'qcrb', a: 'basicInformation' }
  },
  {
    path: '/qcrb/serviceAdmin/:crmid', name: 'serviceAdmin', component: serviceAdmin, meta: { c: 'qcrb', a: 'serviceAdmin' }
  },
  {
    path: '/qcrb/qcrbCloud/:crmid', name: 'qcrbCloud', component: qcrbCloud, meta: { c: 'qcrb', a: 'qcrbCloud' }
  },
  {
    path: '/qcrb/infoManagement/:crmid', name: 'infoManagement', component: infoManagement, meta: { c: 'qcrb', a: 'infoManagement' }
  },
  {
    path: '/qcrb/applyAdmin/:crmid', name: 'applyAdmin', component: applyAdmin, meta: { c: 'qcrb', a: 'applyAdmin' }
  },
  {
    path: '/qcrb/searchList', name: 'searchList', component: searchList, meta: { c: 'qcrb', a: 'searchList' }
  },
  ...langSchoolRouter
];

export default qcrbRouter;
